import { useState } from "react"
import axiosInstance from "../../../../services/axios-client"
import { toast } from "react-toastify"
import { handleApiErrorWithLogs } from "../../../../utils/errorHandler"

const useCalibrator = () => {
    // ============= STATE MANAGEMENT =============
    const [file, setSelectedFile] = useState(null)
    const [fileInputKey, setFileInputKey] = useState(Date.now())
    const [logs, setLogs] = useState(null)
    const [checkCalibrator, setCheckCalibrator] = useState(false)
    const [canSubmit, setCanSubmit] = useState(false)
    const [loadingPagestate, setLoadingPage] = useState(false)

    // ============= FILE HANDLER =============
    const handleFileChange = (event) => {
        const file = event.target.files[0]
        setSelectedFile(file)
        setCheckCalibrator(false)
        setCanSubmit(false)
        setLogs(null) // Clear previous logs
    }

    const clearFileInput = () => {
        setSelectedFile(null)
        setFileInputKey(Date.now())
        setCheckCalibrator(false)
        setCanSubmit(false)
    }

    // ============= API CALLS =============
    const postCalibrator = async (projectID, onSuccess) => {
        try {
            setLoadingPage(true)
            const formData = new FormData()
            formData.append("projectID", projectID)
            formData.append("excelFile", file)

            await axiosInstance.post('/auth/calibrations/upload', formData)
            toast.success("Success Add Calibrator")
            clearFileInput()
            if (onSuccess) {
                onSuccess()
            }
        } catch (error) {
            handleApiErrorWithLogs(error, setLogs)
        } finally {
            setLoadingPage(false)
        }
    }

    const checkEmployeeNik = async (projectID) => {
        try {
            setLoadingPage(true)
            const formData = new FormData()
            formData.append("projectID", projectID)
            formData.append("excelFile", file)

            await axiosInstance.post('/auth/calibrations/upload-employee', formData)
            toast.success("All Employee's NIK are valid")
            setCheckCalibrator(true)
            setLogs(null)
        } catch (error) {
            handleApiErrorWithLogs(error, setLogs)
        } finally {
            setLoadingPage(false)
        }
    }

    const checkCalibratorNik = async (projectID) => {
        try {
            setLoadingPage(true)
            const formData = new FormData()
            formData.append("projectID", projectID)
            formData.append("excelFile", file)

            await axiosInstance.post('/auth/calibrations/upload-calibrator', formData)
            toast.success("All Calibrator's NIK are valid")
            setCanSubmit(true)
            setLogs(null)
        } catch (error) {
            handleApiErrorWithLogs(error, setLogs)
        } finally {
            setLoadingPage(false)
        }
    }

    return {
        file,
        fileInputKey,
        handleFileChange,
        postCalibrator,
        checkEmployeeNik,
        checkCalibratorNik,
        logs,
        checkCalibrator,
        canSubmit,
        loadingPagestate
    }
}

export default useCalibrator